import { FC, useState } from 'react';
import { Currency, DemeterDataFrequency, DemeterFilterTimeSpan, UnitOfMeasure } from '../../../../Generated/Raven-Demeter';
import { IChartBarDataSeries, IChartDataSeries } from '../../../Components/Charts/ChartDefinitions';
import ChartWrapper from '../../../Components/Charts/ChartWrapper/ChartWrapper';
import FilterTimeSpans from '../../../Components/Charts/FilterTimeSpans/FilterTimeSpans';
import ProjectionChartRaw from '../../../Components/Charts/Projection/ProjectionChartRaw';
import styles from './CalendarSpreadCalculator.module.scss';

interface ICalendarSpreadCalculatorContextChart {
    title: string;
    dataSourceTag: string[];
    currency?: Currency | undefined;
    unitOfMeasure?: UnitOfMeasure | undefined;
    linesSeries: IChartDataSeries[];
    barSeries: IChartBarDataSeries;
    displayDecimalPlacesMinimum: number;
    isLoading: boolean;
    handleTimeSpanChange: (timeSpan: DemeterFilterTimeSpan) => void;
}

const availableFilterTimeSpans = [
    DemeterFilterTimeSpan.OneMonth,
    DemeterFilterTimeSpan.SixMonths,
    DemeterFilterTimeSpan.OneYear,
    DemeterFilterTimeSpan.TwoYears,
];

const defaultFilterTimeSpan = DemeterFilterTimeSpan.SixMonths;
const CalendarSpreadCalculatorContextChart: FC<ICalendarSpreadCalculatorContextChart> = (props: ICalendarSpreadCalculatorContextChart) => {
    const [filterTimeSpan, setFilterTimeSpan] = useState<DemeterFilterTimeSpan>(defaultFilterTimeSpan);
    return (
        <div className={styles.calendar_spread_calculator_chart}>
            <ChartWrapper
                name="CalendarSpreadCalculatorChart"
                title={props.title}
                dataSourceTag={props.dataSourceTag}
                isLoading={props.isLoading}
                footer={
                    <FilterTimeSpans
                        name="CalendarSpreadCalculatorChart"
                        filterTimeSpanOptions={availableFilterTimeSpans}
                        filterTimeSpan={filterTimeSpan}
                        handleTimeSpanSelected={(timeSpan) => {
                            props.handleTimeSpanChange(timeSpan);
                            setFilterTimeSpan(timeSpan);
                        }}
                        track={{ eventCategory: 'CalendarSpreadCalculator', eventAction: 'ContextChartTimeSpanChanged', eventValue: filterTimeSpan }}
                    />
                }
                track={{ eventCategory: 'CalendarSpreadCalculator', eventAction: 'ContextChart' }}
            >
                <ProjectionChartRaw
                    linesSeries={props.linesSeries}
                    barSeries={props.barSeries}
                    currency={props.currency}
                    unitOfMeasure={props.unitOfMeasure}
                    displayDecimalPlacesMaximum={props.displayDecimalPlacesMinimum}
                    displayDecimalPlacesMinimum={props.displayDecimalPlacesMinimum}
                    dataFrequency={DemeterDataFrequency.Daily}
                    barSeriesScreenPercent={20}
                />
            </ChartWrapper>
        </div>
    );
};

export default CalendarSpreadCalculatorContextChart;
